import { Generic } from './List';
export function isList(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isList;    //# sourceMappingURL=isList.js.map
